// @flow
import * as React from 'react';

import styles from './CatalogContainer.module.scss';;


type Props = {
  children: React.Node,
}

const CatalogContainer = ({ children }: Props) => (
  <div className={styles.root}>
    {children}
  </div>
);

export default CatalogContainer;
